import { ref } from 'vue'
import axios from 'axios'
import useNotification from '@/composables/useNotification.js'
import { useValidation } from '@/composables/utils/useValidation'
import { useAuth } from '@/composables/auth/useAuth'

const URLS = {
    xhr: {
        mutate: {
            register: '/register'
        }
    }
}

export const useRegisterStep = () => {
    const { isValid } = useValidation()
    const { notification } = useNotification()
    const { userValues, updateProfileOrEventSteps } = useAuth()

    const load = ref(false)
    const visible = ref(false)
    const formValues = ref({
        first_name: '',
        last_name: '',
        email: '',
        password: ''
    })
    const serverErrors = ref({
        first_name: '',
        last_name: '',
        email: '',
        password: ''
    })

    ;(() => _init())()

    async function handleInitialAuthRegister(v) {
        if (isValid(v)) {
            try {
                load.value = true
                const response = await axios.post(URLS.xhr.mutate.register, {
                    ...formValues.value,
                    password_confirmation: formValues.value.password
                })
                _redirectNextStep(response)
                return response
            } catch (error) {
                if (error.response?.data.errors) {
                    const { first_name, last_name, email, password } = error.response.data.errors

                    _parseServerErrors({ first_name, last_name, email, password })
                }
                notification('error', error)
            } finally {
                load.value = false
            }
        } else {
            notification('error', 'Email not valid.')
        }
    }
    function _init() {
        if (userValues.value.email) {
            formValues.value.email = userValues.value.email
        }
    }
    function _redirectNextStep(response) {
        if (response.data?.first_name) {
            userValues.value.firstName = response.data.first_name
            userValues.value.id = response.data.id
        }
        updateProfileOrEventSteps('profile-register', 'artist-register-one')
    }
    function _parseServerErrors({ first_name, last_name, email, password }) {
        if (first_name) {
            serverErrors.value.first_name = first_name[0]
        }
        if (last_name) {
            serverErrors.value.last_name = last_name[0]
        }
        if (email) {
            serverErrors.value.email = email[0]
        }
        if (password) {
            serverErrors.value.password = password[0]
        }
    }
    return {
        load,
        visible,
        formValues,
        serverErrors,

        handleInitialAuthRegister
    }
}
